import { AfterViewInit, Component, DoCheck, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { locales } from 'moment';
import { AutomationService } from 'src/app/services/automation.service';
import { DeviceColumnService } from 'src/app/services/device-column.service';
import { DeviceService } from 'src/app/services/device.service';
import { GroupService } from 'src/app/services/group.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { LoginService } from 'src/app/services/login.service';
import { StandaloneService } from 'src/app/services/standalone.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { Router } from '@angular/router';
import { StackService } from 'src/app/services/stack-service.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceListEmptyComponent } from '../device-list-empty/device-list-empty.component';

@Component({
  selector: 'app-device-list-details',
  templateUrl: './device-list-details.component.html',
  styleUrls: ['./device-list-details.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, DeviceListEmptyComponent]
})
export class DeviceListDetailsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('alerttemplateSocketLost') alertTemplateForSocketLost!: TemplateRef<any>;
  msg: string = "";
  deviceNoteOpen: boolean = false;
  color: boolean = false;
  currentUser: any;
  columnDefinitions: any;
  om: any
  @Input() tracker: TrackerService;
  @Input() columns: { name: string, selected: boolean }[];
  @Input() sort: {
    fixed: { name: string; order: string }[];
    user: { name: string; order: string }[];
  };
  @Input() filter: any;

  devices: any;
  activeColumns = [];
  activeSorting = [];
  activeFilters = [];
  table: HTMLTableElement;
  tbody: HTMLTableSectionElement;
  rows: HTMLCollectionOf<HTMLTableRowElement> | HTMLTableRowElement[];
  prefix = 'd' + Math.floor(Math.random() * 1000000) + '-';
  mapping = Object.create(null);
  childScopes = Object.create(null);
  bridgeHost: any;
  sortedColumns: any;
  transformedColumns: {
    sort: string;
    name: string;
    selected: boolean;
  }[];

  constructor(
    private loginService: LoginService,
    private elementRef: ElementRef,
    private logcatService: LogcatService,
    private automationService: AutomationService,
    private renderer: Renderer2,
    private standaloneService: StandaloneService,
    private deviceColumnService: DeviceColumnService,
    private groupService: GroupService,
    private deviceService: DeviceService,
    private router: Router,
    private stackService: StackService,
    private dialog: MatDialog
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);

  }

  ngOnInit(): void {



    this.transformColumns();


    this.columnDefinitions = this.deviceColumnService.columnDefinitions;


    const element = this.elementRef.nativeElement;
    this.table = element.querySelector('table');

    this.tbody = this.table.createTBody();
    // this.renderer.setProperty(this.tbody,'| sort:','sortField:sortDirection')
    this.rows = this.tbody.rows;



    this.tracker.devices.forEach(this.addListener);


    this.tracker.trackerEventEmitter.subscribe((data: any) => {


      //this.devices.add(data.data);
      if (data.type == "add") {
        this.addListener(data.data);
      }
      if (data.type == "change") {
        this.changeListener(data.data);
      }
      if (data.type == "remove") {
        this.removeListener(data.data);
      }
      this.sortByStatus();
    });

  }

  ngAfterViewInit(): void {

    const element = this.elementRef.nativeElement;
    this.renderer.listen(element, 'click', (event: MouseEvent) => {
      this.checkDeviceStatus(event);
      this.checkDeviceSmallImage(event);
      this.checkDeviceNote(event);
    });

    // Update now so that we don't have to wait for the scope watcher to
    // trigger.
    // this.updateColumns(this.columns());
    // this.columns()
    // Update now so we're up to date.
    //  updateFilters(scope.filter())

  }

  //idar chnage krna hai
  ngOnChanges(changes: SimpleChanges) {
    if (changes['sort']) {
      const newValue = changes['sort'].currentValue;
      this.activeSorting = newValue.fixed.concat(newValue.user);
      this.sortedColumns = {};

      this.activeSorting.forEach((sort) => {
        this.sortedColumns[sort.name] = sort;
      });
      this.sortAll();
    }

    if (changes['columns']) {
      const newValue = changes['columns'].currentValue;

      //
      setTimeout(() => {
        this.updateColumns(newValue);
      }, 0);
    }

    if (changes['filter']) {
      const newValue = changes['filter'].currentValue;
      this.updateFilters(newValue);
    }

    if (this.devices) {
      this.devices.forEach((device) => {
        this.changeListener(device);
      });
    }

    // this.tracker.trackerEventEmitter.subscribe((data: any) => {

    //   //this.devices.add(data.data);
    //   if (data.type == "add") {
    //     this.addListener(data.data);
    //   }
    //   if (data.type == "change") {
    //     this.changeListener(data.data);
    //   }
    //   if (data.type == "remove") {
    //     this.removeListener(data.data);
    //   }
    // });
  }

  ngOnDestroy(): void {
    // check this <------------------------
    // this.tracker.removeListener('add', this.addListener);
    // this.tracker.removeListener('change', this.changeListener);
    // this.tracker.removeListener('remove', this.removeListener);
  }


  transformColumns(): void {
    this.transformedColumns = this.columns.map(column => ({
      ...column, // Spread operator to copy all properties
      sort: 'sort' // Prepend 'sort-' to the sort property
    }));
  }


  kickDevice(device, force) {
    this.stackService.delete(device.serial);
    // this.logcatService.allowClean = true;
    if (Object.keys(this.logcatService.deviceEntries).includes(device.serial)) {
      this.logcatService.deviceEntries[device.serial].allowClean = true

      this.bridgeHost = device.providerUrl;

      this.automationService.stopAppInspector('', device.serial, this.bridgeHost).subscribe((res: any) => {

        sessionStorage.setItem("appInspectorUrl", null);
      });
    }
    // $rootScope.LogcatService = LogcatService  <------------------need to check
    return this.groupService.kick(device, force).catch(function (e) {
      this.msg = "Device kicked from the group";
      this.openAlertMod(this.alertTemplate, this.msg);

      // alert('Device kicked from the group')
      throw new Error(e)
    })
  }

  // inviteDevice(device) {
  //   $rootScope.usedDevices.push(device.serial)
  //   return GroupService.invite(device).then(function () {  <------------------need to check
  //     scope.$digest()
  //   })
  // }


  checkDeviceStatus(e) {
    if (e.target.classList.contains('device-status')) {
      let id = e.target.parentNode.parentNode.id
      let device = this.mapping[id]


      if (device.state === 'available') {
        let groupId = this.currentUser.userObj.groups.subscribed[0];
        //for new backend
        this.checkDeviceOwner(device.serial).subscribe((res: any) => {
          if (res.description && res.description?.email != this.currentUser.email) {
            this.msg = "Device instance is not updated.";
            this.openAlertMod2(this.alertTemplateForSocketLost, this.msg);
          } else {
            this.checkGroupValidation(groupId, device.serial);
          }
        })
      }
      //tulya
      else if (device.state == 'using') {
        this.kickDevice(device, 1)
      }

      // if ($rootScope.adminMode && device.state === 'busy') {
      //   this.kickDevice(device, true)     <------------------need to check
      //   e.preventDefault()
      // }
      // else if (device.using) {
      //   this.kickDevice(device)
      //   e.preventDefault()
      // }
    }
  }

  checkDeviceOwner(serial: any) {
    return this.deviceService.checkDeviceStatus(serial);
  }

  checkGroupValidation(groupId, deviceSerial) {
    //for new backend
    this.automationService.validationUsersAsPerGroup(groupId, deviceSerial);
  }

  checkDeviceSmallImage(e) {


    if (e.target.classList.contains('device-small-image-img')) {
      let id = e.target.parentNode.parentNode.parentNode.id
      let device = this.mapping[id]

      if (device.name && device.image) {
        let title = device.name
        let enhancedPhoto800 = '/static/app/devices/photo/x800/' + device.image
        // LightboxImageService.open(title, enhancedPhoto800)     <---------------- check this
      }
    }
  }

  // On clicking device-note-edit icon
  // This function will create a new angular-xeditable span
  // inside xeditableWrapper and compile it with
  // new child scope.
  // Childscope will be destroyed when the editing will be over
  checkDeviceNote(event: any): void {
    const target = event.target;

    if (target.classList.contains('device-note-edit') && !this.deviceNoteOpen) {
      this.deviceNoteOpen = true;
      const i = target;
      const id = i.parentNode.parentNode.id;
      const device = this.mapping[id];
      const xeditableWrapper = i.parentNode.firstChild;
      const xeditableSpan = document.createElement('span');
      const childScope: any = { id, device };

      this.childScopes[id] = childScope;

      xeditableSpan.setAttribute('editable-text', 'device.notes');
      xeditableSpan.setAttribute('onbeforesave', `updateNote(${id}, ${device.serial}, $data)`);
      xeditableSpan.setAttribute('oncancel', `onDeviceNoteCancel(${id})`);
      xeditableSpan.setAttribute('iseditmode', 'true');
      xeditableSpan.classList.add('ng-scope', 'editable', 'editable-click', 'editable-hide', 'custom-arrow');

      const formElement = document.createElement('form');
      formElement.classList.add('dropdown-toggle', 'form-inline', 'editable-wrap', 'editable-text', 'ng-pristine', 'ng-valid', 'ng-scope');
      formElement.setAttribute('role', 'form');
      formElement.setAttribute('editable-form', '$form');
      formElement.setAttribute('blur', 'cancel');
      formElement.style.cssText = `
      top:-1em;
      position: relative;
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      font-family: "Lato","Helvetica Neue",Helvetica,sans-serif;
      color: #757575;
      user-select: auto;
      border-spacing: 0;
      border-collapse: collapse;
      font-size: 14px;
      line-height: 1.42857143;
      box-sizing: border-box;
      outline: 0 !important;
      white-space: nowrap;
      background: rgb(139 139 139);
      // border: 1px solid #AAA;
      border-radius: 5px;
      // display: inline-block;
      // left: 72%;
      margin: -43px 0px 0px -181px;
      padding: 7px;
      // position: flex;
      // top: -20px;
      width: 380px;
      z-index: 101;
    `;


      formElement.innerHTML = `
        <div class="editable-controls form-group menu" ng-class="{'has-error': $error}" style="display: flex;">
        <input id="editable-input" type="text" class="editable-has-buttons editable-input form-control ng-pristine ng-valid ng-not-empty ng-touched" [(ngModel)]="device.notes" style="width: 100%;">
          <span class="editable-buttons">
            <button type="button" class="btn" style="color: green; --bs-btn-hover-bg: #d3d4d5;" id="saveButton"><i class="fa fa-check"></i></button>
            <button type="button" class="btn btn-default" style="color: red; --bs-btn-hover-bg: #d3d4d5;" id="cancelButton"><i class="fa fa-times"></i></button>
          </span>
          <div class="editable-error help-block ng-binding ng-hide" ng-show="$error" ng-bind="$error" style=""></div>
        </div>
      `;


      xeditableWrapper.appendChild(xeditableSpan);
      xeditableWrapper.appendChild(formElement);

      // Add event listener to the cancel button to remove the form element
      formElement.querySelector('#cancelButton')?.addEventListener('click', () => {
        this.deviceNoteOpen = false;
        //two times required because the chidren are removed one after the other
        this.onDeviceNoteCancel(id);
        this.onDeviceNoteCancel(id);
      });

      // Add event listener to the save button to save the notes
      formElement.querySelector('#saveButton')?.addEventListener('click', () => {
        this.deviceNoteOpen = false;
        const inputElement = formElement.querySelector('#editable-input') as HTMLInputElement;
        if (inputElement) {
          // inputElement.focus();
          //two times required because the chidren are removed one after the other
          this.updateNote(id, device.serial, inputElement.value)
          this.updateNote(id, device.serial, inputElement.value)
        }
      });

      const clickEvent = new MouseEvent('click');
      xeditableSpan.dispatchEvent(clickEvent);
    }

  }

  destroyXeditableNote(id) {
    // let tr = this.tbody.children[id];
    const tr = this.tbody.children[id] as HTMLTableRowElement;
    for (let i = 0; i < tr.cells.length; i++) {
      let col = tr.cells[i]

      if (col.firstChild && col.firstChild.nodeName.toLowerCase() === 'span' &&
        (col.firstChild as HTMLTableRowElement).classList.contains('xeditable-wrapper')) {

        let xeditableWrapper = col.firstChild as HTMLTableRowElement;
        let children = xeditableWrapper.children;

        // Remove all childs under xeditablerWrapper
        for (let j = 0; j < children.length; j++) {
          xeditableWrapper.removeChild(children[j])
        }
      }
    }
    this.childScopes[id] = null;
  }

  updateNote(id, serial, note) {
    this.deviceService.updateNote(serial, note)
    this.destroyXeditableNote(id)
  }

  onDeviceNoteCancel(id) {
    this.destroyXeditableNote(id)
  }

  //for coloring them alternatively finally after every tracker update
  sortByStatus() {
    if (!this.rows) return;

    for (let i = 0; i < this.rows.length; i++) {
      if (i % 2 === 0) {
        this.renderer.setStyle(this.tbody.rows[i], 'background-color', '#bfe5f0');
      } else {
        this.renderer.setStyle(this.tbody.rows[i], 'background-color', 'white');
      }
    }
  }

  sortBy(column, rows, transformedColumns) {


    let columnName = column.name;
    transformedColumns.sort = transformedColumns.sort == "sort-asc" ? "sort-desc" : "sort-asc";

    //new logic  
    const sortedRows = Array.from(this.rows).sort((a: any, b: any) => {

      const aValue = this.mapping[a.id][columnName];
      const bValue = this.mapping[b.id][columnName];


      return transformedColumns.sort == "sort-asc" ? aValue > bValue ? -1 : 1 : aValue > bValue ? 1 : -1; // Adjust this based on ascending/descending order
    });


    // Update your rows array with the sorted data
    this.rows = sortedRows;
    if (!this.rows) return;

    for (let i = 0; i < this.rows.length; i++) {
      if (i % 2 === 0) {
        this.renderer.setStyle(this.rows[i], 'background-color', '#bfe5f0');
      } else {
        this.renderer.setStyle(this.rows[i], 'background-color', 'white');
      }
      // this.insertRow(this.rows[i],this.mapping[this.rows[i].id]); //it works
      this.tbody.insertBefore(this.rows[i], null);
    }
    //new logic  
  }
  // Patches all rows.
  patchAll(patch) {


    // const element = this.elementRef.nativeElement;
    // this.table = element.querySelector('table');
    // this.tbody = this.table.createTBody();
    // this.rows = this.tbody.rows;

    if (!this.rows) return;

    for (let i = 0, l = this.rows.length; i < l; ++i) {
      if (i % 2 === 0) {
        this.renderer.setStyle(this.rows[i], 'background-color', '#bfe5f0');
      } else {
        this.renderer.setStyle(this.rows[i], 'background-color', 'white');
      }
      this.patchRow(this.rows[i], this.mapping[this.rows[i].id], patch);
    }
  }

  // Patches the given row by running the given patch operations in
  // order. The operations must take into account index changes caused
  // by previous operations.
  patchRow(tr, device, patch) {


    for (let i = 0, l = patch.length; i < l; ++i) {
      let op = patch[i]
      switch (op[0]) {
        case 'insert':
          let col = this.columnDefinitions[op[2]]
          tr.insertBefore(col.update(col.build(), device), tr.cells[op[1]])
          this.renderer.setStyle(tr, "white-space", "nowrap");
          break
        case 'remove':
          tr.deleteCell(op[1])
          break
        case 'swap':
          tr.insertBefore(tr.cells[op[1]], tr.cells[op[2]])
          tr.insertBefore(tr.cells[op[2]], tr.cells[op[1]])
          break
      }
    }

    return tr
  }

  // Updates visible columns. This method doesn't necessarily have to be
  // the fastest because it shouldn't get called all the time.
  updateColumns(defaultColumns) {

    let newActiveColumns = []

    // let omii=defaultColumns

    // Check what we're supposed to show now
    defaultColumns.forEach((c) => {
      if (c.selected) {
        newActiveColumns.push(c.name)
      }
    })
    // columnSettings.forEach((column) => {
    //   if (column.selected) {
    //     console.log( column.name,"<<<<<<<<<<<<<<<<<<<column")
    //     newActiveColumns.push(column.name)
    //   }
    // })


    // Figure out the patch
    let patch = this.patchArray(this.activeColumns, newActiveColumns)

    // Set up new active columns
    this.activeColumns = newActiveColumns



    return this.patchAll(patch)
  }

  patchArray(a, b) {
    let ops = []

    let workA = [].concat(a)
    let inA = Object.create(null)
    let itemA, cursorA, itemB, cursorB

    let inB = this.existenceMap(b)
    let posB = Object.create(null)

    // First, check what was removed from a.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]

      // If b does not contain the item, surely it must have been removed.
      if (!inB[itemA]) {
        workA.splice(cursorA, 1)
        ops.push(['remove', cursorA])
      }
      // Otherwise, the item is still alive.
      else {
        inA[itemA] = true
        cursorA += 1
      }
    }

    // Then, check what was inserted into b.
    for (cursorB = 0; cursorB < b.length; ++cursorB) {
      itemB = b[cursorB]

      // If a does not contain the item, it must have been added.
      if (!inA[itemB]) {
        workA.splice(cursorB, 0, itemB)
        ops.push(['insert', cursorB, itemB])
      }

      posB[itemB] = cursorB
    }

    // At this point, workA contains the same items as b, but swaps may
    // be needed.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]
      let posInB = posB[itemA]

      if (posInB === cursorA) {
        cursorA += 1
      }
      else {
        let temp = workA[posInB]
        workA[posInB] = itemA
        workA[cursorA] = temp
        ops.push(['swap', cursorA, posInB])
      }
    }
    return ops
  }

  existenceMap(array) {
    let map = Object.create(null)
    for (let i = 0, l = array.length; i < l; ++i) {
      map[array[i]] = 1
    }
    return map
  }

  // Updates filters on visible items.
  updateFilters(filters) {


    this.activeFilters = filters;
    return this.filterAll();
  }

  // Applies filterRow() to all rows.
  filterAll() {

    if (!this.rows) return;

    for (let i = 0, l = this.rows.length; i < l; ++i) {
      if (i % 2 === 0) {
        this.renderer.setStyle(this.rows[i], 'background-color', '#bfe5f0'); // White for even rows
      } else {
        this.renderer.setStyle(this.rows[i], 'background-color', 'white'); // Light grey for odd rows
      }
      this.filterRow(this.rows[i], this.mapping[this.rows[i].id])
    }
  }

  // Filters a row, perhaps removing it from view.
  filterRow(row, device) {
    if (this.match(device)) {

      row.classList.remove('filter-out')

      if (row.className === 'device-not-usable' || row.className === '') {
        row.style.display = ''

      }
      // else{
      //   row.style.display = 'none';

      // }

    }
    else {
      row.classList.add('filter-out')

      if (row.className === 'device-not-usable filter-out' || row.className === 'filter-out') {

        row.style.display = 'none';
      }
      else {
        row.style.display = ''
      }

    }

  }

  // Checks whether the device matches the currently active filters.
  match(device) {




    for (let i = 0, l = this.activeFilters.length; i < l; ++i) {
      let filter = this.activeFilters[i]
      let column
      if (filter.field) {

        column = this.columnDefinitions[filter.field]

        if (column && !column.filter(device, filter)) {
          return false
        }
      }
      else {
        let found = false


        for (let j = 0, k = this.activeColumns.length; j < k; ++j) {
          column = this.columnDefinitions[this.activeColumns[j]]


          if (column && column.filter(device, filter)) {


            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }
    }
    return true
  }

  // Calculates a DOM ID for the device. Should be consistent for the
  // same device within the same table, but unique among other tables.
  calculateId(device) {
    return this.prefix + device.serial;
  }

  // Compares two devices using the currently active sorting. Returns <0
  // if deviceA is smaller, >0 if deviceA is bigger, or 0 if equal.
  compare(deviceA: any, deviceB: any) {
    const mapping = {
      asc: 1,
      desc: -1
    };

    let diff: any;

    // Find the first difference
    for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
      const sort = this.activeSorting[i];
      diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
      if (diff !== 0) {
        diff *= mapping[sort.order];
        break;
      }
    }

    return diff;
  }

  // Creates a completely new row for the device. Means that this is
  // the first time we see the device.
  createRow(device) {
    let id = this.calculateId(device)
    let tr = document.createElement('tr')
    let td
    tr.id = id
    if (!device.usable) {
      tr.classList.add('device-not-usable')
    }
    for (let i = 0, l = this.activeColumns.length; i < l; ++i) {
      td = this.columnDefinitions[this.activeColumns[i]].build()
      this.columnDefinitions[this.activeColumns[i]].update(td, device)
      tr.appendChild(td)
    }

    this.mapping[id] = device
    return tr
  }
  // Updates all the columns in the row. Note that the row must be in
  // the right format already (built with createRow() and patched with
  // patchRow() if necessary).
  updateRow(tr, device) {
    let id = this.calculateId(device)

    tr.id = id

    if (!device.usable) {
      tr.classList.add('device-not-usable')
    }
    else {
      tr.classList.remove('device-not-usable')
    }

    for (let i = 0, l = this.activeColumns.length; i < l; ++i) {
      this.columnDefinitions[this.activeColumns[i]].update(tr.cells[i], device)
    }

    return tr
  }

  // Inserts a row into the table into its correct position according to
  // current sorting.
  insertRow(tr, deviceA) {
    if (!this.rows) return;

    return this.insertRowToSegment(tr, deviceA, 0, this.rows.length - 1)
  }

  // Inserts a row into a segment of the table into its correct position
  // according to current sorting. The value of `hi` is the index
  // of the last item in the segment, or -1 if none. The value of `lo`
  // is the index of the first item in the segment, or 0 if none.
  insertRowToSegment(tr, deviceA, low, high) {
    if (!this.rows) return;

    let total = this.rows.length
    let lo = low
    let hi = high

    if (lo > hi) {
      // This means that `lo` refers to the first item of the next
      // segment (which may or may not exist), and we should put the
      // row before it.
      this.tbody.insertBefore(tr, lo < total ? this.rows[lo] : null)
    }
    else {
      let after = true
      let pivot = 0
      let deviceB

      while (lo <= hi) {
        pivot = ~~((lo + hi) / 2)
        deviceB = this.mapping[this.rows[pivot].id]

        let diff = this.compare(deviceA, deviceB)

        if (diff === 0) {
          after = true
          break
        }

        if (diff < 0) {
          hi = pivot - 1
          after = false
        }
        else {
          lo = pivot + 1
          after = true
        }
      }

      if (after) {
        this.tbody.insertBefore(tr, this.rows[pivot].nextSibling)
      }
      else {
        this.tbody.insertBefore(tr, this.rows[pivot])
      }
    }
  }

  // Compares a row to its siblings to see if it's still in the correct
  // position. Returns <0 if the device should actually go somewhere
  // before the previous row, >0 if it should go somewhere after the next
  // row, or 0 if the position is already correct.
  compareRow(tr, device) {
    let prev = tr.previousSibling
    let next = tr.nextSibling
    let diff

    if (prev) {
      diff = this.compare(device, this.mapping[prev.id])
      if (diff < 0) {
        return diff
      }
    }

    if (next) {
      diff = this.compare(device, this.mapping[next.id])
      if (diff > 0) {
        return diff
      }
    }

    return 0
  }

  // // Sort all rows.
  sortAll() {
    if (this.rows) {
      // This could be improved by getting rid of the array copying. The
      // copy is made because rows can't be sorted directly.
      let sorted = [].slice.call(this.rows).sort(function (rowA, rowB) {
        return this.compare(this.mapping[rowA.id], this.mapping[rowB.id])
      })

      // Now, if we just append all the elements, they will be in the
      // correct order in the table.
      for (let i = 0, l = sorted.length; i < l; ++i) {
        this.tbody.appendChild(sorted[i])
      }
    }
  }

  // Triggers when the tracker sees a device for the first time.
  addListener = (device) => {
    this.color = !this.color;


    let row = this.createRow(device);

    this.filterRow(row, device);
    if (this.color)
      this.renderer.setStyle(row, 'background-color', '#bfe5f0');
    else
      this.renderer.setStyle(row, 'background-color', 'white');
    // this.insertRow(row, device);
    this.tbody.insertBefore(row, null);


  }

  // Triggers when the tracker notices that a device changed.
  changeListener(device) {
    let id = this.calculateId(device)
    let tr = this.tbody.children[id]

    if (tr) {
      // First, update columns
      this.updateRow(tr, device)


      // Maybe the row is not sorted correctly anymore?
      let diff = this.compareRow(tr, device)

      if (diff < 0) {
        // Should go higher in the list
        this.insertRowToSegment(tr, device, 0, tr.rowIndex - 1)
      }
      else if (diff > 0) {
        if (!this.rows) return;

        // Should go lower in the list
        this.insertRowToSegment(tr, device, tr.rowIndex + 1, this.rows.length - 1)
      }

    }
  }

  // Triggers when a device is removed entirely from the tracker.
  removeListener(device) {
    let id = this.calculateId(device)
    let tr = this.tbody.children[id]

    if (tr) {
      this.tbody.removeChild(tr)
    }

    delete this.mapping[id]
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  openAlertMod2(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

  Reload() {
    window.location.reload();
  }
}
